import React, { useMemo, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { getControlStyle } from '../../helper';
import CommonAction from '../../../Pages/Library/DPP/Library/TemplateComponent/CommonAction';
import noImage from '../../../assets/images/no-image.png';
import * as Action from '../../../Pages/SupplierSuggestion/store/SupplierSuggestion.action';

export function CareUserLabelInstruction(props) {
  const { t } = useTranslation('common');
  const { devOrderId } = useParams();
  const dispatch = useDispatch();
  const [sectionPermission, setSectionPermission] = useState(null);

  const {
    otherConfiguration,
    dataIndex,
    editingInput,
    deleteItem,
    careLabelDescriptionArr,
    dppAddEditAccess,
    careLabelsArr,
    subHeading,
    sectionId,
    setDppState,
    addMoreInfo,
    fromProduct,
    expColl,
  } = props;

  const toggleDrop = () => {
    setDppState((otherStates) => ({
      ...otherStates,
      careExp: !expColl?.careExp,
    }));
  };

  const emptyCareLabel = useMemo(() => {
    if (careLabelsArr?.length === 1) {
      if (!careLabelsArr?.[0]?.careLabel || !careLabelsArr?.[0]?.fieldName) {
        return true;
      }
    }
    return false;
  }, [careLabelsArr]);

  useEffect(() => {
    if (props?.navigateId === 'care-user-instructions-id') {
      setDppState((otherStates) => ({
        ...otherStates,
        navigateId: null,
        careExp: true,
      }));
    }
  }, [props?.navigateId]);

  const renderToggleIcon = () => {
    return (
      <span
        id="collapsible-care"
        className={`icon-new-down-arrow-icon drop-icon ml-16 f-18 ${expColl?.careExp ? 'rotated' : ''}`}
        onClick={() => toggleDrop()}
      />
    );
  };

  const setImage = (image) => {
    let imagePath = '';
    if (image?.includes('data:image/')) {
      imagePath = image;
    } else if (image) {
      imagePath = `https://${process.env.REACT_APP_BUCKET_NAME}.s3.${process.env.REACT_APP_AWS_REGION}.amazonaws.com/${image}`;
    } else {
      imagePath = noImage;
    }
    return imagePath;
  };

  useEffect(() => {
    const callFn = async () => {
      if (devOrderId) {
        const obj = {
          devOrderId,
        };
        const careLabelPermission = await dispatch(Action.getCareLabelPermission(obj));
        setSectionPermission(careLabelPermission?.isVisibleToSupplier);
      }
    };

    callFn();
  }, [devOrderId, dispatch]);

  return (
    <div className="care-label-control" id={sectionId}>
      {!emptyCareLabel && (
        <div>
          <h3 className="main-title d-flex align-items-center">
            <span className="title-text">{t('DPP.CONTROL.CARE_USER_LABEL.EMPTY_CARE_LABEL_TITLE')}</span>
            {renderToggleIcon()}
          </h3>
          <p className="f-16 mb-8" style={getControlStyle(otherConfiguration, 'subHeadAlignment', 'subHeadColour', 'subHeadBold')}>
            {subHeading}
          </p>
          {/* <div className="sub-heading mb-24">{t("DPP.CONTROL.CARE_USER_LABEL.TITLE")}</div> */}
        </div>
      )}
      {emptyCareLabel && (
        <div className="empty-carelabel">
          <div className="title-image-container mb-24">
            <div className="image-container">
              <i className="icon icon-DAM-1" />
            </div>
            <div className="title">{t('DPP.CONTROL.CARE_USER_LABEL.SUB_HEADER_PLACEHOLDER')}</div>
          </div>

          <div className="description">{t('DPP.CONTROL.PRODUCTJOURNEY.DESCRIPTION_PLACEHOLDER')}</div>
        </div>
      )}
      {!emptyCareLabel ? (
        <div id="care-instructions" className={expColl?.careExp ? 'd-block' : 'd-none'}>
          {careLabelsArr?.map((care) => {
            // Check if the current care item should render images
            const isImageColumn = care?.fieldName?.columnDetails?.columnType?.key === 'Image';
            const hasSectionPermission = sectionPermission?.[care?.careLabel?._id];
            const shouldRenderImages = isImageColumn && (fromProduct ? hasSectionPermission : true);

            // Check if the current care item should render text
            const shouldRenderText = !isImageColumn && (hasSectionPermission || !fromProduct);
            if (shouldRenderImages) {
              return (
                <div className="care-image-container mt-2" key={care?.fieldName?._id}>
                  {care?.columnValues?.slice(0, 8)?.map((val) => (
                    <img
                      key={val}
                      src={setImage(val?.value?.image) || noImage}
                      alt=""
                      onError={(e) => {
                        e.target.onerror = null; // Prevent infinite loop
                        e.target.src = noImage; // Replace with fallback image
                      }}
                    />
                  ))}
                </div>
              );
            }

            if (shouldRenderText) {
              return (
                <div key={care?.fieldName?._id}>
                  <span className="f-16 text-bold">{care?.careLabel?.name}:</span>
                  <p className="f-16 mb-0 text-bold" style={getControlStyle(otherConfiguration, 'careAlignment', 'careColour', 'careBold')}>
                    {care?.columnValues?.map((vl) => vl?.value).join(', ')}
                  </p>
                </div>
              );
            }

            return null; // Return null if no conditions match
          })}

          {addMoreInfo === 'yes' ? (
            <div>
              {careLabelDescriptionArr?.map((carDes) => {
                return (
                  <div key={carDes} className="other-details mt-24">
                    <div className="image-details">
                      <img src={setImage(carDes?.image) || noImage} alt="" />
                      <span className="font-heavy">{carDes?.title}</span>
                    </div>
                    <p style={getControlStyle(otherConfiguration, 'descriptionAlignment', 'descriptionColour', 'descriptionBold')}>{carDes?.description}</p>
                  </div>
                );
              })}
            </div>
          ) : null}
        </div>
      ) : null}

      <CommonAction editingInput={editingInput} deleteItem={deleteItem} dataIndex={dataIndex} dppAddEditAccess={dppAddEditAccess} />
    </div>
  );
}
export default CareUserLabelInstruction;
